// extracted by mini-css-extract-plugin
module.exports = {"itemsWrapper":"_12252fc","itemBox":"_1b18d48","countryList":"_2890a45","phoneNumberBox":"_a506ffb","dropdownLabel":"_dd42f9d","wrapper":"_f64df6a","info":"_02dc909"};